import type { AuthorizedResource } from '@/services/bff/permission.api';
import { EMPLOYEE_PORTAL_PERMISSION_RESOURCES } from './definitions';
import { SETTINGS_PERMISSION_RESOURCES } from './settingsDefinitions';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export const buildPermissionKey = (resourceCode: string, action?: string) =>
  action ? `${resourceCode}:${action}` : resourceCode;

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  const access: AuthorizedResourceAccessMap = {};
  const apply = (resource: AuthorizedResource, allowed: boolean) => {
    if (resource.code === '*') {
      [
        ...EMPLOYEE_PORTAL_PERMISSION_RESOURCES,
        ...SETTINGS_PERMISSION_RESOURCES,
      ].forEach((item) => {
        if (resource.actions?.includes('*')) {
          access[item.code] = allowed;
          item.actions.forEach((action) => {
            access[buildPermissionKey(item.code, action.name)] = allowed;
          });
          return;
        }
        item.actions.forEach((action) => {
          if (resource.actions?.includes(action.name)) {
            access[buildPermissionKey(item.code, action.name)] = allowed;
          }
        });
      });
      return;
    }

    access[resource.code] = allowed;
    (resource.actions ?? []).forEach((action) => {
      if (action) access[buildPermissionKey(resource.code, action)] = allowed;
    });
  };

  authorizedResources
    .filter((resource) => isAuthorizedResourceAllowed(resource.effect))
    .forEach((resource) => {
      apply(resource, true);
    });
  authorizedResources
    .filter((resource) => resource.effect === 'DENY')
    .forEach((resource) => {
      apply(resource, false);
    });

  return access;
}
